export default __webpack_public_path__ + "static/media/hyperspace-no-2.7a4b9ed1.mid";